import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';

const EBilling = () => {
  const gnbuttonclick = () => {
    window.open("https://web10.secureinternetbank.com/PBI_PBI1151/Login/271070924")
  }
  return (
    <div>
      <SimpleHero
        title="Paperless statements, simplified"
        subtitle="Fast, secure e‑statements and payments. Reduce paper, increase convenience."
        primaryLabel="Enroll now"
        primaryHref="#"
        variant="sofi"
        badges={["Convenient","Secure","Eco‑friendly"]}
      />
      <FeatureList
        items={[
          { title: 'Convenient', desc: 'Access statements anytime, on any device.' },
          { title: 'Secure', desc: 'Encrypted delivery keeps your info safe.' },
          { title: 'Eco‑friendly', desc: 'Go green with paperless billing.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <button className="btn btn-gn-primary" onClick={() => {gnbuttonclick()}}>Get started</button>
        </div>
      </section>
    </div>
  );
};

export default EBilling;
